export default __webpack_public_path__ + "static/pixel-pro-4a1d9a3577ae0a15357c3ee3c4828ebe.jpg";